import React, { useState, useEffect, useRef } from "react";
import Home from "./Registration";
const HomePage = () => {

  return (
    <>
   <Home/>
    </>
  );
};

export default HomePage;
